import ScrollCarousel, { measureSlidesPerView } from '../../components/ScrollCarousel';

const SELECTORS = {
  viewport: '[data-press-tag-carousel-viewport]',
  track: '[data-press-tag-carousel-track]',
};

// The mobile markup is a separate, non-carousel list; the carousel only shows
// once there are enough tags to overflow.
const MIN_TAGS = 3;

const carousels = [];

export default function () {
  document.querySelectorAll('[data-press-tag-carousel]').forEach((el) => {
    if (
      el.getAttribute('initialized') === 'true' ||
      document.querySelectorAll('.PressTagCarousel--carousel .PressTagCarousel__tag').length <= MIN_TAGS
    ) {
      return;
    }

    const viewport = el.querySelector(SELECTORS.viewport);
    const track = el.querySelector(SELECTORS.track);
    if (!viewport || !track || track.children.length === 0) {
      return;
    }

    el.setAttribute('initialized', 'true');

    const slides_per_view = measureSlidesPerView(viewport, track.children[0]);

    const carousel = new ScrollCarousel(el, {
      selectors: SELECTORS,
      // No `wrapAround` here; `contain: true` is handled in SCSS.
      loop: false,
      prevNextButtons: true,
      // Page dots were hidden in SCSS under Flickity; keep them off.
      pageDots: false,
      draggable: true,
      slidesPerView: slides_per_view,
      // Flickity `groupCells: true`.
      slidesPerGroup: slides_per_view,
      ariaLabel: 'Press categories carousel',
    });

    carousels.push(carousel);
  });
}
